<template>
  <div class="table_form">
    <section>
      <img :src="obj.user_avatar" alt="" />
      <div>
        <b>{{ obj.alias_name }}</b>
        <p>
          <span>{{obj.sex}}</span>
          <span>{{obj.age}}岁</span>
        </p>
      </div>
    </section>
    <el-link type="primary" @click="goHome(obj.user_app_id)">查看主页</el-link>
    <el-link type="primary">查看文件</el-link>
    <el-button type="primary" @click="goChat(obj.user_app_id)">去聊呗</el-button>
  </div>
</template>
<script>
// 
import { mapGetters } from 'vuex'

export default {
  props: {

    obj: {
      type: Object,
      default: {
          alias_name:'',
          user_avatar:'',
          user_app_id:'',
          sex:'',
          age:''
        }
    },
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'isLogin',
      'user_type'// 1 求职 2 招聘
    ]),
  },

  data () {
    return {

    }
  },
  created () { },
  mounted () { },

  methods:{
    goHome(user_app_id){
      this.$goUserHome(user_app_id);

    },
    goChat(user_app_id){
      console.log("goChat");
      this.$goChat(this.userInfo.user_app_id,user_app_id);
    }
  }


  // 应用组件

};
</script>
<style lang="scss" scoped>
.table_form {
  width: 571px;
  height: 98px;
  box-sizing: border-box;
  border-radius: 6px;
  border: 1px solid #cccccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 20px;
  margin-bottom: 19px;
  section {
    display: flex;
    img {
      width: 43px;
      height: 43px;
      margin-right: 15px;
    }
    div {
      width: 130px;
      height: 43px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      b {
        font-size: 16px;
        color: #333;
      }
      span {
        font-size: 11px;
        margin-right: 20px;
        color: #666;
      }
    }
  }
}
</style>